export function drawLetterboxedSource(
  ctx: CanvasRenderingContext2D,
  source: CanvasImageSource,
  sourceWidth: number,
  sourceHeight: number,
  targetSize: number,
) {
  if (sourceWidth <= 0 || sourceHeight <= 0) {
    throw new Error('Image source has invalid dimensions')
  }

  const scale = Math.min(targetSize / sourceWidth, targetSize / sourceHeight)
  const width = Math.round(sourceWidth * scale)
  const height = Math.round(sourceHeight * scale)
  const x = Math.round((targetSize - width) / 2)
  const y = Math.round((targetSize - height) / 2)

  ctx.clearRect(0, 0, targetSize, targetSize)
  ctx.fillStyle = 'rgb(114, 114, 114)'
  ctx.fillRect(0, 0, targetSize, targetSize)
  ctx.drawImage(source, x, y, width, height)
}
